import {SET_SELECTED_EFFECT} from 'constants/action-types.js';
import {SET_IS_MACRO_MAPPING} from 'constants/action-types.js';
import {SET_PARAMETER_TO_MAP} from 'constants/action-types.js';
import {SET_EFFECT_PARAMETER_VALUE} from 'constants/action-types.js';
import {SET_PULLED_EFFECTS} from 'constants/action-types.js';
import {SET_EFFECT_PARAMETER_VALUES} from 'constants/action-types.js';
import {SET_MIDI_EFFECT_DRAGGING} from 'constants/action-types.js';
import {NEW_SEQUENCE} from 'constants/action-types.js';
import {SET_EFFECT_COLLAPSED} from 'constants/action-types.js';
import {SET_BULK_EFFECTS_COLLAPSED} from 'constants/action-types.js';
import {SET_EFFECTS_CHAIN_TO_SHOW} from 'constants/action-types.js';
import {SET_EFFECTS_CHAINS_TO_SHOW} from 'constants/action-types.js';
import {SET_SELECTED_SEND_EFFECT} from 'constants/action-types.js';
import {SET_EFFECT_RACK_NODE_POSITION} from 'constants/action-types.js';
import {SET_SCRIPT_VARIABLES} from 'constants/action-types.js';
import {SET_COPIED_NODES_FOR_RACK} from 'constants/action-types.js';
import {SET_SELECTED_PALETTE} from 'constants/action-types.js';
import {SET_SEQUENCED_PALETTE} from 'constants/action-types.js';
import {SET_PARAMETER_MIN_MAX} from 'constants/action-types.js';
import {SET_ACCUMULATOR_PARAMETER_SELECTED} from 'constants/action-types.js';
import {SET_PLANE_MAPPING} from 'constants/action-types.js';
import {SET_LINKING_EFFECTS} from 'constants/action-types.js';
import {SET_ALL_EFFECT_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_EFFECT_PATTERN_LOCKS} from 'constants/action-types.js';
import {SET_EFFECT_STARRED} from 'constants/action-types.js';
import {SET_BULK_EFFECTS_STARRED} from 'constants/action-types.js';

let initialState = {
    linkingEffects: undefined,
    scriptVariables: {},
    selectedEffect: undefined,
    parameterToMap: undefined,
    pulledEffects: [],
    selectedSendEffect: undefined,
    selectedPalettes: {},
    sequencedPalettes: {},
    effectParameters: {},
    midiEffectDragging: undefined,
    effectCollapsed: {},
    effectsChainToShow: {},
    effectRackNodePositions: {},
    isMacroMapping: false,
    copiedNodesForRack: [],
    planeMapping: undefined,
    parameterMinMax: {},
    effectPatternLocks: {},
    effectStarred: {}
};

const effectsReducer = (state = initialState, action) => {
    let newState;
    let obj = {... state};
    switch (action.type) {
    case NEW_SEQUENCE:
        return initialState;
    case SET_PULLED_EFFECTS:
        return {
            ... state,
            pulledEffects: action.payload
        };
    case SET_EFFECT_STARRED:
        let {effectStarred} = state;
        effectStarred[action.payload.id] = action.payload.starred;
        return {
            ... state,
            effectStarred
        };
    case SET_BULK_EFFECTS_STARRED:
        return {
            ... state,
            effectStarred: action.payload
        };
    case SET_SELECTED_EFFECT:
        return {...state, selectedEffect: action.payload};
    case SET_IS_MACRO_MAPPING:
        return {...state, isMacroMapping: action.payload};
    case SET_PARAMETER_TO_MAP:
        return {...state, parameterToMap: action.payload};
    case SET_SELECTED_SEND_EFFECT:
        return {...state, selectedSendEffect: action.payload};
    case SET_MIDI_EFFECT_DRAGGING:
        return {...state, midiEffectDragging: action.payload};
    case SET_COPIED_NODES_FOR_RACK:
        return {...state, copiedNodesForRack: action.payload};
    case SET_ACCUMULATOR_PARAMETER_SELECTED:
        return {...state, accumulatorParameterSelected: action.payload};
    case SET_PARAMETER_MIN_MAX:
        let {parameterMinMax} = state;
        return {
            ... state,
            parameterMinMax: {
                ... parameterMinMax,
                ... action.payload
            }
        };
    case SET_EFFECT_PARAMETER_VALUE:
        obj = {... state};
        obj.effectParameters[action.payload.id] = action.payload.value;
        return obj;
    case SET_EFFECT_PARAMETER_VALUES:
        let parameters = {
            ...state.effectParameters,
            ... action.payload
        };
        return {
            ... state,
            effectParameters: parameters,
        };
    case SET_EFFECTS_CHAIN_TO_SHOW:
        let effectsChains = {...state.effectsChainToShow};
        let subSequenceEffectsChains =
            effectsChains[action.payload.subSequenceId] || {};
        subSequenceEffectsChains[action.payload.trackNumber] =
            action.payload.chainNumber;
        effectsChains[action.payload.subSequenceId] =
            subSequenceEffectsChains;
        return {
            ... state,
            effectsChainToShow: effectsChains,
        };
    case SET_BULK_EFFECTS_COLLAPSED:
        return {
            ... state,
            effectCollapsed: {
                ... state.effectCollapsed,
                ... action.payload
            }
        };
    case SET_EFFECT_COLLAPSED:
        obj = {... state};
        obj.effectCollapsed[action.payload.id] = action.payload.isCollapsed;
        return obj;
    case SET_EFFECTS_CHAINS_TO_SHOW:
        obj = {... state};
        obj.effectsChainToShow[action.payload.subSequenceId] =
            action.payload.effectsChains;
        return obj;
    case SET_EFFECT_RACK_NODE_POSITION:
        let rackNodePositions = state.effectRackNodePositions[action.payload.rackId] || {};
        rackNodePositions[action.payload.effectId] =
            {
                x: action.payload.x,
                y: action.payload.y
            };
        let effectRackNodePositions = {
            ... state.effectRackNodePositions
        };
        effectRackNodePositions[action.payload.rackId] = rackNodePositions;
        return {
            ... state,
            effectRackNodePositions: effectRackNodePositions
        };
    case SET_SCRIPT_VARIABLES:
        let scriptVariables = {... state.scriptVariables};
        scriptVariables[action.payload.id] = action.payload.variables;
        return {
            ... state,
            scriptVariables
        };
    case SET_SELECTED_PALETTE:
        let selectedPalettes = {... state.selectedPalettes};
        selectedPalettes[action.payload.trackId] = action.payload.palette;
        return {
            ... state,
            selectedPalettes: selectedPalettes
        };
    case SET_SEQUENCED_PALETTE:
        let sequencedPalettes = {... state.sequencedPalettes};
        sequencedPalettes[action.payload.trackId] = action.payload.palette;
        return {
            ... state,
            sequencedPalettes
        };
    case SET_PLANE_MAPPING:
        return {
            ... state,
            planeMapping: action.payload
        };
    case SET_LINKING_EFFECTS:
        return {
            ... state,
            linkingEffects: action.payload
        };
    case SET_ALL_EFFECT_PATTERN_LOCKS:
        return {
            ... state,
            effectPatternLocks: {
                ... state.effectPatternLocks,
                ... action.payload
            }
        };
    case SET_EFFECT_PATTERN_LOCKS:
        let effectPatternLocks = {... state.effectPatternLocks};
        effectPatternLocks[action.payload.id] = action.payload.patternLocks;
        return {
            ... state,
            effectPatternLocks
        };
    default:
        return state;
    }
}

export default effectsReducer;
